// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'money';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M14.063 3.375H1.687c-.62 0-1.125.504-1.125 1.125v6.75c0 .621.504 1.125 1.125 1.125h12.376c.62 0 1.124-.504 1.124-1.125V4.5c0-.621-.503-1.125-1.124-1.125z' />
    <path d='M3.094 6.188a.281.281 0 0 1 0-.563m0 .563a.281.281 0 0 0 0-.563m9.562 4.5a.281.281 0 0 1 0-.563m0 .563a.281.281 0 1 0 0-.563' />
    <path d='M7.875 10.125a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5zm9.563-3.375v6.75a1.125 1.125 0 0 1-1.125 1.125H3.938' />
  </g>
);

export const viewBox = '0 0 18 18';
